import './dashboard.css'
import React from 'react';
import Axios from 'axios';
import { mockChartData } from '../mockChartData'
import Chart from 'chart.js' 
import GenerateLinkModal from './GenerateLinkModal/GenerateLinkModal';
import { baseUrl } from '../assets/Animations';
import MarketingStats from './MarketingStats/MarketingStats';
import SchoolDataDashboard from './SchoolDataDashboard/SchoolDataDashboard';
import axios from 'axios';
import { format, isValid } from 'date-fns';
import BackUpInfoData from './BackUpInfoData/BackUpInfoData';
import InquiryByTown from './InquiryByTown/InquiryByTown';
import InquiryByInstrument from './InquiryByInstrument/InquiryByInstrument';
import LTVArea from './LTVArea/LTVArea';

import {APIProvider, AdvancedMarker, InfoWindow, Map, Pin} from '@vis.gl/react-google-maps';
import { getSchoolIANATimezone } from '../Calendar/calendarFunctions';
import { id } from 'date-fns/locale';


const Dashboard = (props) => {
    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }
    // const [schoolData, setSchoolData] = React.useState({})
    // const [dataMMA, setDataMMA] = React.useState({})    
    // const [dataLSMA, setDataLSMA] = React.useState({})
    // const [dataTSMA, setDataTSMA] = React.useState({})
    // const [dataGLMA, setDataGLMA] = React.useState({})
    // const [dataAll, setAllData] = React.useState({})
    // let chartRefMMA = React.createRef()
    // let chartRefLSMA = React.createRef()
    // let chartRefTSMA = React.createRef()
    // let chartRefGLMA = React.createRef()
    // let chartRefALL = React.createRef()
    const [projectedRevenue, setProjectedRevenue] = React.useState(0)
    const [projectedPayOut, setProjectedPayOut] = React.useState(0)
    const [showGenerateLinkModal, setShowGenerateLinkModal] = React.useState(false)
    const [emailToReset, setEmailToReset] = React.useState('')
    const [teacherInStateStorage, setTeacherInStateStorage] = React.useState({})
    const [allStudents, setAllStudents] = React.useState([])
    const [days, setDays] = React.useState(0)
    const [hours, setHours] = React.useState(0)
    const [minutes, setMinutes] = React.useState(0)
    const [seconds, setSeconds] = React.useState(0)

    const [mmaNew, setMmaNew] = React.useState(0)
    const [mmaOld, setMmaOld] = React.useState(0)
    const [lsmaNew, setLsmaNew] = React.useState(0)
    const [lsmaOld, setLsmaOld] = React.useState(0)
    const [tsmaNew, setTsmaNew] = React.useState(0)
    const [tsmaOld, setTsmaOld] = React.useState(0)
    const [totalStudents, setTotalStudents] = React.useState(0)
    const [totalOld, setTotalOld] = React.useState(0)
    const [totalNew, setTotalNew] = React.useState(0)
    const [gifs, setGifs] = React.useState([
       "https://media.giphy.com/media/12XDYvMJNcmLgQ/giphy.gif",
       "https://media.giphy.com/media/1xVbRS6j52YSzp9P7N/giphy.gif",
       "https://media.giphy.com/media/xT9DPIBYf0pAviBLzO/giphy.gif",
       "https://media.giphy.com/media/QPThyMR3U76LQhdpYJ/giphy.gif",
       "https://media.giphy.com/media/rhC8duvjyYNhRxMBbQ/giphy.gif",
       "https://media.giphy.com/media/idUgpCC6XLoK0ZNZ2o/giphy.gif",
       "https://media.giphy.com/media/yLzaPIw1LLHZS/giphy.gif"
    ])
    const [randomNumber, setRandomNumber] = React.useState(10)
    const [emailToSetToPassword, setEmailToSetToPassword] = React.useState('')
    const [studentHearOfUs, setStudentHearOfUs] = React.useState({facebook: 0, google: 0, referral: 0, lessons: 0})
    const [backUpInfosByMonth, setBackUpInfosByMonth] = React.useState([])
    const [view, setView] = React.useState('towns')
    const [deleteTempFamilies, setDeleteTempFamilies] = React.useState([])
    const [deleteGeoLocations, setDeleteGeoLocations] = React.useState([])


    
    // React.useEffect(() => {
    //     getTheListOfStudents()
    //     getTheChartInformation()
    // },[])
    // React.useEffect(() => {
    //     const MyChartRef = chartRefMMA.current.getContext("2d");
    //     new Chart(MyChartRef, {
    //         type: "line",
    //         data: dataMMA,
    //         options: {
    //             scales: {
    //                 yAxes: [{
    //                     ticks: {  
    //                       beginAtZero: false,
    //                       min: 40,
    //                       max: 70,
                          
    //                       stepSize: 1,
    //                     }
    //                   }] 
    //             }
    //         }
    //     })
    // }, [dataMMA])
    // React.useEffect(() => {
    //     const MyChartRef = chartRefLSMA.current.getContext("2d");
    //     new Chart(MyChartRef, {
    //         type: "line",
    //         data: dataLSMA,
    //         options: {
    //             scales: {
    //                 yAxes: [{
    //                     ticks: {  
    //                       beginAtZero: true,
    //                       max: 40,
                          
    //                       stepSize: 1,
    //                     }
    //                   }] 
    //             }
    //         }
    //     })
    // }, [dataLSMA])
    // React.useEffect(() => {
    //     const MyChartRef = chartRefTSMA.current.getContext("2d");
    //     new Chart(MyChartRef, {
    //         type: "line",
    //         data: dataTSMA,
    //         options: {
    //             scales: {
    //                 yAxes: [{
    //                     ticks: {  
    //                       beginAtZero: true,
    //                       max: 40,
                          
    //                       stepSize: 1,
    //                     }
    //                   }] 
    //             }
    //         }
    //     })
    // }, [dataTSMA])
    // React.useEffect(() => {
    //     const MyChartRef = chartRefGLMA.current.getContext("2d");
    //     new Chart(MyChartRef, {
    //         type: "line",
    //         data: dataGLMA,
    //         options: {
    //             scales: {
    //                 yAxes: [{
    //                     ticks: {  
    //                       beginAtZero: true,
    //                       max: 30,
                          
    //                       stepSize: 1,
    //                     }
    //                   }] 
    //             }
    //         }
    //     })
    // }, [dataGLMA])
    // React.useEffect(() => {
    //     const MyChartRef = chartRefALL.current.getContext("2d");
    //     new Chart(MyChartRef, {
    //         type: "line",
    //         data: dataAll,
    //         options: {
    //             scales: {
    //                 yAxes: [{
    //                     ticks: {
    //                         min: 55,
    //                       max: 120,
    //                       stepSize: 1,
    //                     }
    //                   }] 
    //             }
    //         }
    //     })
    // }, [dataAll])

    // const getTheListOfStudents = () => {
    //     if (window.location.href.startsWith('http://localhost:3000')) {
    //         //tallySchools(mockStudentData)
    //         return
    //     } else {
    //         let myToken = localStorage.getItem('token')
    //         Axios.get("https://app.atharo.app/school-management", {
    //             headers: { Authorization: `Bearer ${myToken}` }
    //         })
    //         .then(response => {
    //             const data = response.data
    //             tallySchools(data)
    //         })
    //         .catch(e => {
    //             console.log('Error retrieving data: ' + e)
    //             console.log(e)
    //         })
    //     }
    // }
    // const getTheChartInformation = () => {
    //     // if (window.location.href.startsWith('http://localhost:3000')) {
    //     //     generateCharts(mockChartData)
    //     // } else {
    //         let myToken = localStorage.getItem('token')
    //         Axios.get("https://app.atharo.app/charts", {
    //             headers: { Authorization: `Bearer ${myToken}` }
    //         })
    //         .then(response => {
    //             const data = response.data
    //             generateCharts(data)
    //         })
    //         .catch(e => {
    //             console.log('Error retrieving data: ' + e)
    //             console.log(e)
    //         })
    //     //}
    // }
    // const generateCharts = (data) => {
    //     let xAxisArray = []
    //     let mmaActiveArray = []
    //     let tsmaActiveArray = []
    //     let lsmaActiveArray = []
    //     let glmaActiveArray = []
    //     let allActiveArray = []
    //     for(let i = 0; i < data.length; i++) {
    //         xAxisArray.push(i)
    //         mmaActiveArray.push(data[i].Schools.MMA.Active)
    //         tsmaActiveArray.push(data[i].Schools.TMA.Active)
    //         lsmaActiveArray.push(data[i].Schools.LSMA.Active)
    //         glmaActiveArray.push(data[i].Schools.GLMA.Active)
    //         let total = data[i].Schools.MMA.Active + data[i].Schools.TMA.Active + data[i].Schools.LSMA.Active + data[i].Schools.GLMA.Active
    //         allActiveArray.push(total)
    //     }
    //     setDataMMA({
    //         labels: xAxisArray,
    //         datasets: [
    //             {
    //                 label: "MMA/Active",
    //                 data: mmaActiveArray,
    //                 backgroundColor: 'rgba(128, 77, 0, 0.5)'
    //             }
    //         ]
    //     })
    //     setDataLSMA({
    //         labels: xAxisArray,
    //         datasets: [
    //             {
    //                 label: "LSMA/Active",
    //                 data: lsmaActiveArray,
    //                 backgroundColor: 'rgba(9, 0, 128, 0.5)'
    //             }
    //         ]
    //     })
    //     setDataTSMA({
    //         labels: xAxisArray,
    //         datasets: [
    //             {
    //                 label: "TSMA/Active",
    //                 data: tsmaActiveArray,
    //                 backgroundColor: 'rgba(0, 128, 58, 0.5)'
    //             }
    //         ]
    //     })
    //     setDataGLMA({
    //         labels: xAxisArray,
    //         datasets: [
    //             {
    //                 label: "GLMA/Active",
    //                 data: glmaActiveArray,
    //                 backgroundColor: 'rgba(98, 0, 128, 0.5)'
    //             }
    //         ]
    //     })
    //     setAllData({
    //         labels: xAxisArray,
    //         datasets: [
    //             {
    //                 label: "All/Active",
    //                 data: allActiveArray,
    //                 backgroundColor: 'rgba(98, 0, 128, 0.5)'
    //             }
    //         ]
    //     })
    // }
    // const tallySchools = (data) => {
    //     let schoolHash = {MMA: {Families: 0, Active: 0, Prospective: 0, Break: 0}, LSMA: {Families: 0, Active: 0, Prospective: 0, Break: 0}, TMA: {Families: 0, Active: 0, Prospective: 0, Break: 0}, GLMA: {Families: 0, Active: 0, Prospective: 0, Break: 0}}
    //     for(let i = 0; i < data.length; i++) {
    //         let school = data[i].School
    //         let family = data[i]
    //         if(family.Status === 'Active' || family.Status === 'Prospective' || family.Status === 'Taking a Break') {
    //             schoolHash[school].Families ++
    //         }
    //         for(let i = 0; i < family.Students.length; i++) {
    //             if(family.Students[i].Status === 'Active') {
    //                 schoolHash[school].Active ++
    //             } else if(family.Students[i].Status === 'Prospective') {
    //                 schoolHash[school].Prospective ++
    //             } else if(family.Students[i].Status === 'Taking a Break') {
    //                 schoolHash[school].Break ++
    //             }
    //         }
    //     }
    //     setSchoolData(schoolHash)
    // }



    React.useEffect(() => {
        getTeachersAndStudents()
        countdownTimer()
        let myNum = Math.floor(Math.random() * (6 - 0 + 1) + 0)
        //console.log(myNum)
        setRandomNumber(myNum)
        deleteGetTeachersFamilies()
    }, [])

    React.useEffect(() => {
        if(allStudents !== []) {
            tallyPrices()
        }
    }, [allStudents])

    // const getAndMoveAllBlogs = () => {
    //     Axios.get(`${baseUrl}/blogstoreview`, myHeader)
    //     .then((res) => {
    //         moveTheBlogs(res.data)
    //     })
    // }

    // const moveTheBlogs = (blogs) => {
    //     console.log(blogs.length)
    //     for(let i = 0; i < blogs.length; i++) {
    //         let blog = blogs[i]

    //         let totalWordCount = 0
    //         for(let i = 0; i < blog.Sections.length; i++) {
    //             if(blog.Sections[i].content) {
    //                 totalWordCount = totalWordCount + blog.Sections[i].content.trim().split(/\s+/).length
    //             }
    //         }
    //         let blogImage = ''
    //         let looking = true
    //         for(let i = 0; i < blog.Sections.length; i++) {
    //             if(blog.Sections[i].type === 'image' && looking) {
    //                 blogImage = blog.Sections[i].content
    //                 looking = false
    //             }
    //         }


    //         let punctuationless = blog.GoogleTitle.replace(/[.,\/#!?$%\^&\*;:{}=|\-_'`~()]/g,"");
    //         let finalString = punctuationless.replace(/\s{2,}/g," ");
    //         let theUrl = finalString.replace(/ /g,'-').toLowerCase()
    //         setTimeout(() => {
    //         Axios.post(`${baseUrl}/tempblogpost`, {
    //             Id: blog.Id,
    //             Author: blog.Author,
    //             AuthorImageUrl: `https://app.atharo.app/images/${blog.Author.split(" ").join("").toLowerCase()}.jpg`,
    //             Date: blog.Date,
    //             GoogleTitle: blog.GoogleTitle,
    //             Url: theUrl,
    //             ArticleImage: blogImage,
    //             Title: blog.Sections[0].content,
    //             WordCount: totalWordCount,
    //             GoogleMeta: blog.GoogleMeta,
    //             Category: 'mind',
    //             Canonical: false,
    //             CanonicalUrl: '',
    //             GoogleMeta: blog.GoogleMeta,
    //             Sections: blog.Sections,
    //             Status: blog.Status,
    //             School: blog.School,
    //         })
    //         .then((res) => {
    //             console.log('it worked')
    //             console.log(res.data.Preview.GoogleTitle)
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         })
    //         }, 1000 * i)
    //     }
    // }

    const getTeachersAndStudents = async () => {
        let students = await getAllStudents()
        let teachers = await getTeachers()
        if(teachers) {
            for(let i = 0; i < teachers.length; i++) {
                teachers[i].newStudentList = []
            }
            calculateAndSortByNumberOfStudents(students, teachers)
        }
    }
    const calculateAndSortByNumberOfStudents = (theStudents, theTeachers) => {
        let allRevenue = 0
        let amountPaidOut = 0
        for(let i = 0; i < theStudents.length; i++) {
           if(theStudents[i].status === 'Active') {
               for(let j = 0; j < theStudents[i].students.length; j++) {
                   if(theStudents[i].students[j].familyStatus === 'Active') {
                       let theTeachersId = theStudents[i].students[j].teachersId
                        for(let k = 0; k < theTeachers.length; k++) {
                            if(theTeachers[k].TeacherID === theTeachersId) {
                                theTeachers[k].newStudentList.push({
                                    firstName: theStudents[i].students[j].studentName,
                                    lastName: theStudents[i].familyName,
                                    allRates: theStudents[i].students[j].allRates,
                                    lessonLength: theStudents[i].students[j].lessonLength
                                })
                                // console.log(theStudents[i].Family)
                                // console.log(Number(theStudents[i].Students[j].Length) / 60 )
                                // console.log(Number(theTeachers[k].Rate))
                                // console.log((Number(theStudents[i].Students[j].Length) / 60 ) * Number(theTeachers[k].Rate))
                                // console.log('-')
                                amountPaidOut = amountPaidOut + (((Number(theStudents[i].students[j].lessonLength) / 60 ) * Number(theTeachers[k].Rate)) * 4)
                                // console.log(theStudents[i].Family)
                                // console.log(theStudents[i].Students[j].Rate)
                                // console.log(allRevenue + (Number(theStudents[i].Students[j].Rate) * 4))
                                let theLessonLength = theStudents[i].students[j].lessonLength
                                allRevenue = allRevenue + (Number(theStudents[i].students[j].allRates[theLessonLength]) * 4)
                            }
                        }
                   }
               }
           } 
        }
        setProjectedPayOut(amountPaidOut)
        setProjectedRevenue(allRevenue)
    }
    const getAllStudents = async () => {
        let myToken = localStorage.getItem('token')
        return Axios.get(`${baseUrl}/school-management`, {
            headers: { Authorization: `Bearer ${myToken}` }
        })
        .then(res => {
            setAllStudents(res.data)
            tallyInquirySources(res.data)
            setBackUpInfosByMonth(tallyWhenStudentsJoinedByMonth(res.data))
            return res.data
        })
        .catch(err => {
            console.log(err)
            return
        })
    }
    const getTeachers = async () => {
          let myToken = localStorage.getItem('token')
          return Axios.get(`${baseUrl}/initialadminrequest`, {
              headers: { Authorization: `Bearer ${myToken}` }
          })
          .then(response => {
            //console.log(response.data)
            //   let sortedData = this.sortByStudent(response.data)
            //     setTimeout(function() {
            //       this.setState({
            //           allTeachers: sortedData,
            //           filteredTeachers: sortedData,
            //           dateFilteredTeachers: sortedData
            //       }, () => {





                //ADD A NEW CATAGORY TO KEEP TRACK OF TEACHERS STUDENTS 
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].newStudentList = []
                }
                //----------------------------------------------------
                // this.setState({
                //     allTeachers: response.data,
                //     filteredTeachers: response.data,
                //     dateFilteredTeachers: response.data
                // }, () => {
                //     this.bigFilter()
                //     setTimeout(function() {
                //         let offset = 0
                //         let allofThem = document.getElementsByClassName("admin-teacher-card")
                //         for(let i = 0; i < allofThem.length; i++) {
                //             allofThem[i].style.transition = `transform 300ms, opacity 600ms linear ${offset}ms`
                //             allofThem[i].style.opacity = "1"
                //             offset = i * 50
                //         }
                //     }, 10)
                // })
                return response.data
            //     }.bind(this), 75)
          })
          .catch(function (error) {
            console.log(error)
            return
          })
    }

    const tallyInquirySources = (studentList) => {
        let myObject = {facebook: 0, google: 0, referral: 0, lessons: 0}
        for(let i = 0; i < studentList.length; i++) {
            myObject[studentList[i].hearOfUs] = myObject[studentList[i].hearOfUs] + 1
            if (studentList[i].hearOfUs === 'lessons.com') {
                myObject['lessons'] = myObject['lessons'] + 1
            }
        }
        setStudentHearOfUs(myObject)
    }

    const getTeachersInformation = () => {
        Axios.get(`${baseUrl}/data/${emailToReset}`, myHeader)
        .then((res) => {
            setTeacherInStateStorage(res.data)
            //console.log(res.data)
            console.log('teacher info got')
            deleteTeacherFromDatabase(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }
    const deleteTeacherFromDatabase = (data) => {
        Axios.delete(`${baseUrl}/data/${data.TeacherID}`, myHeader)
        .then((res) => {
            console.log('teacher deleted')
            //console.log(res)
            //console.log(res.data)
            createTeacherAgainInDatabase(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }
    const createTeacherAgainInDatabase = (teacherObject) => {
        console.log('the state teacher')
        //console.log(teacherInStateStorage)
        Axios.post(`${baseUrl}/reregister`, {
            ReUpTeacher: teacherObject
        })
        .then((res) => {
            console.log('teacher created again!')
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const resetPasswordToPassword = () => {
        Axios.put(`${baseUrl}/emergencypassreset`, {
            Secret: 'dpEWyb',
            Email: emailToSetToPassword,
        }, myHeader)
        .then((res) => {
            alert(`${res.data.Name}'s password has been reset to password`)
        })
        .catch((err) => {
            alert(err)
        })
    }

    const tallyPrices = () => {
        let mmaPriceObject = {}
        let lsmaPriceObject = {}
        let tmaPriceObject = {}
        let mountOld = 0
        let mountNew = 0
        let lmaOld = 0
        let lmaNew = 0
        let tmaOld = 0
        let tmaNew = 0
        let mma = 0
        let lsma = 0
        let tma = 0
        for(let i = 0; i < allStudents.length; i++) {
            //console.log(allStudents[i].students)
            if(allStudents[i].school === 'MMA' && allStudents[i].familyStatus === "Active") {
                let family = allStudents[i]
                for(let j = 0; j < family.students.length; j++) {
                    if(family.students[j].studentStatus === 'Active') {
                        mma = mma + 1
                        let theRate = family.students[j].allRates[family.students[j].lessonLength]
                        if((theRate === 43 || theRate === 45) && family.students[j].lessonLength === 30){
                            mountNew++
                        } else if ((theRate === 58 || theRate === 60) && family.students[j].lessonLength === 45) {
                            mountNew++
                        } else if ((theRate === 73 || theRate === 75) && family.students[j].lessonLength === 60) {
                            mountNew++
                        } else {
                            mountOld++
                        }
                        if(mmaPriceObject[theRate]) {
                            mmaPriceObject[theRate]++
                        } else {
                            mmaPriceObject[theRate] = 1
                        }
                    }
                }
            } else if (allStudents[i].school === 'LSMA' && allStudents[i].familyStatus === 'Active') {
                let family = allStudents[i]
                for(let j = 0; j < family.students.length; j++) {
                    if(family.students[j].studentStatus === 'Active') {
                        lsma = lsma + 1
                        let theRate = family.students[j].allRates[family.students[j].lessonLength]
                        if((theRate === 43 || theRate === 45) && family.students[j].lessonLength === 30){
                            lmaNew++
                        } else if ((theRate === 58 || theRate === 60) && family.students[j].lessonLength === 45) {
                            lmaNew++
                        } else if ((theRate === 73 || theRate === 75) && family.students[j].lessonLength === 60) {
                            lmaNew++
                        } else {
                            lmaOld++
                        }
                        if(lsmaPriceObject[theRate]) {
                            lsmaPriceObject[theRate]++
                        } else {
                            lsmaPriceObject[theRate] = 1
                        }
                    }
                }
            } else if (allStudents[i].school === 'TMA' && allStudents[i].familyStatus === 'Active') {
                let family = allStudents[i]
                for(let j = 0; j < family.students.length; j++) {
                    if(family.students[j].studentStatus === 'Active') {
                        tma = tma + 1
                        let theRate = family.students[j].allRates[family.students[j].lessonLength]
                        if((theRate === 43 || theRate === 45) && family.students[j].lessonLength === 30){
                            tmaNew++
                        } else if ((theRate === 58 || theRate === 60) && family.students[j].lessonLength === 45) {
                            tmaNew++
                        } else if ((theRate === 73 || theRate === 75) && family.students[j].lessonLength === 60) {
                            tmaNew++
                        } else {
                            tmaOld++
                        }
                        if(tmaPriceObject[theRate]) {
                            tmaPriceObject[theRate]++
                        } else {
                            tmaPriceObject[theRate] = 1
                        }
                    }
                }
            }  else if (allStudents[i].school === 'MOR' && allStudents[i].familyStatus === 'Active') {
                let family = allStudents[i]
                for(let j = 0; j < family.students.length; j++) {
                    if(family.students[j].studentStatus === 'Active') {
                        tma = tma + 1
                        let theRate = family.students[j].allRates[family.students[j].lessonLength]
                        if((theRate === 43 || theRate === 45) && family.students[j].lessonLength === 30){
                            tmaNew++
                        } else if ((theRate === 58 || theRate === 60) && family.students[j].lessonLength === 45) {
                            tmaNew++
                        } else if ((theRate === 73 || theRate === 75) && family.students[j].lessonLength === 60) {
                            tmaNew++
                        } else {
                            tmaOld++
                        }
                        if(tmaPriceObject[theRate]) {
                            tmaPriceObject[theRate]++
                        } else {
                            tmaPriceObject[theRate] = 1
                        }
                    }
                }
            }
        }
        setMmaNew(mountNew)
        setMmaOld(mountOld)
        setLsmaNew(lmaNew)
        setLsmaOld(lmaOld)
        setTsmaNew(tmaNew)
        setTsmaOld(tmaOld)
        setTotalStudents(mountNew + mountOld + lmaNew + lmaOld + tmaNew + tmaOld)
        setTotalOld(mountOld + lmaOld + tmaOld)
        setTotalNew(mountNew + lmaNew + tmaNew)

    }
    const countdownTimer = () => {
            let end = new Date('01/01/2023 11:59 PM');
    
            let _second = 1000;
            let _minute = _second * 60;
            let _hour = _minute * 60;
            let _day = _hour * 24;
            let timer;
    
            const showRemaining = () => {
            let now = new Date();
            let distance = end - now;
            if (distance < 0) {
    
                clearInterval(timer);
                document.getElementById('countdown').innerHTML = 'EXPIRED!';
    
                return;
            }   
                setDays(Math.floor(distance / _day))
                setHours(Math.floor((distance % _day) / _hour))
                setMinutes(Math.floor((distance % _hour) / _minute))
                setSeconds(Math.floor((distance % _minute) / _second))
        }
    
        timer = setInterval(showRemaining, 1000);
    }

    const processAllInvoices = () => {
        Axios.get(`${baseUrl}/allinvoices`, myHeader)
        .then((res) => {
            let myMap = {}
            for(let i = 0; i < res.data.length; i++) {
                if(myMap[res.data[i].familyId]) {
                    if(res.data[i].monthYear = "August/2022") {
                        myMap[res.data[i].familyId].stillTaking = true
                    }
                    myMap[res.data[i].familyId].total = myMap[res.data[i].familyId].total + 1 
                    let currentInvoiceTotal = 0
                    if(res.data[i].lessonsToBeBilled) {
                        res.data[i].lessonsToBeBilled.forEach(element => {
                            //console.log(element)
                            //console.log(element.lessonRate)
                            if(element.studentAllRates) {
                                currentInvoiceTotal = currentInvoiceTotal + element.studentAllRates[element.lessonLength]
                            } else {
                                console.log('---------------------------')
                                //console.log(res.data[i])
                                console.log('missing allrates')
                                console.log('--------------------------')
                            }
                        });
                        myMap[res.data[i].familyId].revenue = myMap[res.data[i].familyId].revenue + currentInvoiceTotal
                    } else {
                        //console.log(res.data[i].lessonsToBeBilled)
                        console.log('missing?')
                    }
                } else {
                    myMap[res.data[i].familyId] = {total: 1, name: res.data[i].familyName, revenue: 0, stillTaking: false}
                    let currentInvoiceTotal = 0
                    if(res.data[i].lessonsToBeBilled) {
                        res.data[i].lessonsToBeBilled.forEach(element => {
                            //console.log(element)
                            //console.log(element.lessonRate)
                            if(element.studentAllRates) {
                                currentInvoiceTotal = currentInvoiceTotal + element.studentAllRates[element.lessonLength]
                            } else {
                                console.log('---------------------------')
                                //console.log(res.data[i])
                                console.log('missing allrates')
                                console.log('--------------------------')
                            }
                        });
                        myMap[res.data[i].familyId].revenue = currentInvoiceTotal
                    } else {
                        //console.log(res.data[i].lessonsToBeBilled)
                        console.log('missing??')
                    }
                }
            }
            //console.log(myMap)
            let myNewMap = {}
            let totalRevenue = 0
            let totalOfFamilies = 0
            for (const [key, value] of Object.entries(myMap)) {
                if(isNaN(myMap[key].revenue)) {
                    console.log('found a NaN family')
                } else {
                    totalRevenue = totalRevenue + myMap[key].revenue
                    totalOfFamilies = totalOfFamilies + 1
                }
                //console.log(key);
            }
            //console.log('Total Revenue: ' + totalRevenue)
            //console.log('Families: ' + totalOfFamilies)
            //console.log('Average Family Revenue: ' + (totalRevenue / totalOfFamilies))
        })
        .catch((err) => console.log(err))
        let myRateMap = {}
        let stuTotal = 0
        let rateTotal = 0
        Axios.get(`${baseUrl}/school-management`, myHeader)
        .then((res) => {
            for(let i = 0; i < res.data.length; i++) {
                if(res.data[i].familyStatus === 'Active') {
                    res.data[i].students.forEach(stu => {
                        if(stu.studentStatus === 'Active') {
                            if(myRateMap[stu.allRates[30]]) {
                                stuTotal = stuTotal + 1
                                rateTotal = rateTotal + stu.allRates[30]
                                myRateMap[stu.allRates[30]] = myRateMap[stu.allRates[30]] + 1
                            } else {
                                stuTotal = stuTotal + 1
                                rateTotal = rateTotal + stu.allRates[30]
                                myRateMap[stu.allRates[30]] = 1
                            }
                        }
                    })
                }
            }
            //console.log(myRateMap)
            //console.log(rateTotal / stuTotal)
        })
        .catch(err => console.log(err))
    }

    const publicVapidKey = "BGixs1zoGVg72ASp4itTFiM0CwHz-DPDYw4nYFH8gMxziUerwX5e-jTdhY8qXcL61FHDauPnS3pjAjIhJjwqDV4"

    const testSendNotification = () => {
        if('serviceWorker' in navigator) {
            send().catch(err => console.error(err))
        }
        axios.post(`${baseUrl}/subscribe`, {

        })
    }

    const send = async () => {
        const register = await navigator.serviceWorker.register('../service-worker.js', {
            scope: '/'
        })

        const subscription = await register.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
        })

        await axios.post(`${baseUrl}/subscribe`, subscription, {headers: {'content-type': 'application/json'}})

        console.log('Subscribed...')
    }

    const urlBase64ToUint8Array = (base64String) => {
        const padding = '='.repeat((4 - base64String.length % 4) % 4)
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/')

        const rawData = window.atob(base64)
        const outputArray = new Uint8Array(rawData.length)

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i)
        }
        return outputArray
    }

    const tallyWhenStudentsJoinedByMonth = (families) => {
        let myMap = {}
        families.forEach(fam => {
            if(isValid(new Date(fam.onboardDate))) {
                myMap[format(new Date(fam.onboardDate), 'MMM yyyy')] ? myMap[format(new Date(fam.onboardDate), 'MMM yyyy')] = myMap[format(new Date(fam.onboardDate), 'MMM yyyy')] + fam.students.length : myMap[format(new Date(fam.onboardDate), 'MMM yyyy')] = 1
            }
        })
        let myArray = []
        for (const [key, value] of Object.entries(myMap)) {
            myArray.push({month: key, total: value})
        }
        return sortByMonthAscending(myArray)
    }

    function sortByMonthAscending(array) {
        array.sort((a, b) => {
          const monthA = new Date(a.month).getTime();
          const monthB = new Date(b.month).getTime();
          return monthA - monthB;
        });
        return array;
      }


      //--------------------------------------------------------------------------------------

    const deleteGetTeachersFamilies = () => {
        axios.get(`${baseUrl}/teachersfamilies/06eef65cd541a8`, myHeader)
        .then((res) => {
            setDeleteTempFamilies(res.data)
        })
        .catch((err) => console.log(err))
    }

    React.useEffect(() => {
        if(deleteTempFamilies.length > 0) {
            //checkAllAddresses()
        }
    }, [deleteTempFamilies])

    const checkAllAddresses = async () => {
        let allGeoLocations = []
        let ethan = await getEthanLatLong()
        if(ethan) {
            allGeoLocations.push(ethan)
        }
        for(let i = 0; i < deleteTempFamilies.length; i++) {
            let res = await getGeo(deleteTempFamilies[i])
            if(res) {
                allGeoLocations.push(res)
            }
        }
        setDeleteGeoLocations(allGeoLocations)
        console.log(allGeoLocations)
    }

    const replaceSpacesWithPlus = (string) => {
        let newString = ''
        for(let i = 0; i < string.length; i++) {
            if(string[i] === ' ') {
                newString = newString + '+'
            } else {
                newString = newString + string[i]
            }
        }
        return newString
    }

    React.useEffect(() => console.log(deleteGeoLocations), [deleteGeoLocations])

    const getEthanLatLong = async () => {
        let myAddress = '3119+Westwood+Ct,+Boulder,+CO'
        return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${myAddress}&key=AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ`)
        .then((res) => {
            if(res.data.status === 'OK') {
                //create random id, name, and location
                //add to deleteGeoLocations
                let myId = Math.floor(Math.random() * (100000000 - 0 + 1) + 0)
                let myName = 'Ethan'
                let myLocation = res.data.results[0].geometry.location
                let myObject = {id: myId, name: myName, location: myLocation, home: true}
                return myObject
            }
        })
        .catch((err) => {
            console.log(err)
            return null
        })
    }

    const getGeo = async (fam) => {
        //replace spaces with + signs


        let myAddress = `${replaceSpacesWithPlus(fam.address.addressLine1)},+${fam.address.city},+${fam.address.state}`
        return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${myAddress}&key=AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ`)
        .then((res) => {
            if(res.data.status === 'OK') {
                //create random id, name, and location
                //add to deleteGeoLocations
                let myId = Math.floor(Math.random() * (100000000 - 0 + 1) + 0)
                let myName = fam.familyName
                let myLocation = res.data.results[0].geometry.location
                let myObject = {id: myId, name: myName, location: myLocation, home: false}
                return myObject
            }
        })
        .catch((err) => {
            console.log(err)
            return null
        })
    }

    //--------------------------------------------------------------------------------------
      

    const CustomMarkers = ({points}) => {
        return (
            <>
                {points.map((location, index) => {
                        return(
                            <AdvancedMarker key={location.id} position={location.location}>
                                <Pin background={location.home ? 'blue' : 'red'} borderColor={location.home ? 'blue' : '#B31413'} glyphColor={location.home ? 'white' : '#B31413'} />
                                <InfoWindow position={location.location}><p>{location.name}</p></InfoWindow>
                            </AdvancedMarker>
                        )
                    })}
            </>
        )
    }


    return(
        <div className="whole-dashboard-page">
            {/* <div style={{width: '1200px', height: '600px'}}>
                <APIProvider apiKey={'AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ'}>
                    <Map       
                        zoom={12}
                        center={{lat: 40.0150, lng: -105.2705}}
                        gestureHandling={'greedy'}
                        disableDefaultUI={true}
                        mapId={'3324feda48bc0f19'}
                    >
                        <CustomMarkers points={deleteGeoLocations} />
                        </Map>
                </APIProvider>
            </div> */}


            {/* <h1 onClick={() => processAllInvoices()}>Click It Dude</h1> */}
            {/* {props.userData.Name === 'Prescott Blackler' && <SchoolDataDashboard />} */}
            {/* <div onClick={() => testSendNotification()}>CLICK TO RUN</div> */}
            <BackUpInfoData backUpInfosByMonth={backUpInfosByMonth} allStudents={allStudents} />
            {props.userData.Name === 'Prescott Blackler' && <LTVArea/> }
            <div>
                <select onChange={(e) => setView(e.target.value)}>
                    <option value='towns'>Town Inquiries</option>
                    <option value='instruments'>Instrument Inquiries</option>
                </select>
            </div>
            {/* {view === 'towns' && <InquiryByTown students={allStudents} />}
            {view === 'instruments' && <InquiryByInstrument students={allStudents} />} */}
            {props.userData.Name === 'Prescott Blackler' && <MarketingStats />}
            <div className='dashboard__courtney-project-wrapper'>
                <div className='dashboard__student-totals__wrapper'>
                    <h4 className='where-did-they-hear'>Where Did Students Hear About Us</h4>
                    <h5>Google: <strong>{studentHearOfUs['google']}</strong></h5>
                    <h5>Lessons: <strong>{studentHearOfUs['lessons']}</strong></h5>
                    <h5>Referrals: <strong>{studentHearOfUs['referral']}</strong></h5>
                    <h5>Facebook: <strong>{studentHearOfUs['facebook']}</strong></h5>
                </div>
                {/* <div className='dashboard__courtney__leftside'>
                    <div className='courtney-leftside__title'>🎉Project Get Courtney To Full Time🎉</div>
                    <div className='courtney-leftside-timer'>{days} Days {hours} Hours {minutes > 9 ? minutes : `0${minutes}`} Minutes {seconds > 9 ? seconds : `0${seconds}`} Seconds Left</div>
                    <div>
                        <div className='courtney-leftside__goal'>Goal: 105 Students @ the new price</div>
                        <div className='courtney-leftside__to-go'>{105 - totalNew} STUDENTS TO GO!</div>
                        <div className='courtney-leftside__total-students'>Students Enrolled: {totalStudents}</div>
                    </div>
                </div>
                <img className='motivational-gif' src={gifs[randomNumber]}/> */}
                <div className='profile-reset-wrappers'>
                    <div className='reset-wrapper__password-wrapper'>
                        <div className='password-wrapper__text'>Type in teacher's email to reset their password back to "password"</div>
                        <div className='password-wrapper__input-wrapper'>
                            <input className='password-wrapper__input-box' value={emailToSetToPassword} placeholder='Teacher Email' onChange={(e) => setEmailToSetToPassword(e.target.value)} />
                        </div>
                        <div className='dashboard__password-reset-button' onClick={() => resetPasswordToPassword()}>Reset Password</div>
                    </div>
                </div>
            </div>
            {/* <div onClick={() => tallyPrices()}>CLICK TO RUN</div> */}
            {showGenerateLinkModal && <GenerateLinkModal setShowGenerateLinkModal={setShowGenerateLinkModal} />}
            {/* {props.userData.Name === 'Prescott Blackler' || props.userData.Name === 'Danit Yeshaya' ? <h3>Revenue: {projectedRevenue}</h3> : null}
            {props.userData.Name === 'Prescott Blackler' || props.userData.Name === 'Danit Yeshaya' ? <h3>Payments: {projectedPayOut}</h3> : null}
            {props.userData.Name === 'Prescott Blackler' || props.userData.Name === 'Danit Yeshaya' ? <h3>{projectedRevenue - projectedPayOut}</h3> : null} */}
            <div className="generate-link-button" onClick={() => setShowGenerateLinkModal(true)}>Generate Link</div>
            <div>
                <input value={emailToReset} placeholder="Email to Reset" onChange={(e) => setEmailToReset(e.target.value)} />
            </div>        
            <div>
                <div className="reset-profile-btn" onClick={() => getTeachersInformation()}>Reset Profile</div>
            </div>
            {/* <div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="dashboard-table-rows">MMA</th>
                            <th className="dashboard-table-rows">LSMA</th>
                            <th className="dashboard-table-rows">TSMA</th>
                            <th className="dashboard-table-rows">GLMA</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr className="dashboard-console-families">
                            <td>Families</td>
                            {schoolData.MMA && <td>{schoolData.MMA['Families']}</td>}
                            {schoolData.MMA && <td>{schoolData.LSMA['Families']}</td>}
                            {schoolData.MMA && <td>{schoolData.TMA['Families']}</td>}
                            {schoolData.MMA && <td>{schoolData.GLMA['Families']}</td>}
                        </tr>
                        <tr className="dashboard-console-active">
                            <td>Active</td>
                            {schoolData.MMA && <td>{schoolData.MMA['Active']}</td>}
                            {schoolData.MMA && <td>{schoolData.LSMA['Active']}</td>}
                            {schoolData.MMA && <td>{schoolData.TMA['Active']}</td>}
                            {schoolData.MMA && <td>{schoolData.GLMA['Active']}</td>}
                        </tr>
                        <tr className="dashboard-console-prosp">
                            <td>Prospective</td>
                            {schoolData.MMA && <td>{schoolData.MMA['Prospective']}</td>}
                            {schoolData.MMA && <td>{schoolData.LSMA['Prospective']}</td>}
                            {schoolData.MMA && <td>{schoolData.TMA['Prospective']}</td>}
                            {schoolData.MMA && <td>{schoolData.GLMA['Prospective']}</td>}
                        </tr>
                        <tr className="dashboard-console-break">
                            <td>Break</td>
                            {schoolData.MMA && <td>{schoolData.MMA['Break']}</td>}
                            {schoolData.MMA && <td>{schoolData.LSMA['Break']}</td>}
                            {schoolData.MMA && <td>{schoolData.TMA['Break']}</td>}
                            {schoolData.MMA && <td>{schoolData.GLMA['Break']}</td>}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="all-dashboard-charts">
                <div className="my-dashboard-chart">
                    <canvas style={{'width': '100%'}} id="myChart" ref={chartRefMMA}/>
                </div>
                <div className="my-dashboard-chart">
                    <canvas style={{'width': '100%'}} id="myChart" ref={chartRefLSMA}/>
                </div>
                <div className="my-dashboard-chart">
                    <canvas style={{'width': '100%'}} id="myChart" ref={chartRefTSMA}/>
                </div>
                <div className="my-dashboard-chart">
                    <canvas style={{'width': '100%'}} id="myChart" ref={chartRefGLMA}/>
                </div>
                <div className="my-dashboard-chart">
                    <canvas style={{'width': '100%'}} id="myChart" ref={chartRefALL}/>
                </div>
            </div> */}
        </div>
    )
}
export default Dashboard;